import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'
import * as Sentry from "@sentry/browser";

export default class extends Controller {
  static targets = [
    "List", "ListItem", "LoadingSpinner", "EmptyMessage", "HideOnEmpty", "RowTotalPrice", "SummaryOrderItem", "SummarySubtotalAmount",
    "FullLoadingSpinner", "SubmitButton", "EarlySeasonPromoNotice"
  ]
  static values = {
    trackConversion: Boolean
  }

  connect() {
    this.quantityIsUpdating = false
    if (this.trackConversionValue) {
      this.trackConversionEvent()
    }
  }

  preventDefault(e) {
    e.preventDefault()
  }

  trackConversionEvent() {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'AddToCart',
        'conversionValue': 3.50
      })
    }
    // if (window.gtag) {
    //   gtag('event', 'AddToCart', { event_category: 'Lead', currency: 'USD', value: 3.50 })
    //   gtag('event', 'conversion', {'send_to': 'AW-779913037/Pv1_CPOT9ocYEM2O8vMC', 'value': 3.50, 'currency': 'USD'})
    // }
    // if (window.fbq) {
    //   window.fbq('track', 'AddToCart', { currency: 'USD', value: 3.50 })
    // }
    // if (window.uetq) {
    //   window.uetq.push('event', 'add_to_cart', {"revenue_value":3.50,"currency":"USD"});
    // }
  }

  async updateRegenPackOrderItem(responseJson) {
    const hasRegenPack = responseJson.hasRegenPack
    if (hasRegenPack) {
      const regenPackOrderItem = this.SummaryOrderItemTargets.find((target) => target.dataset.orderItemId == responseJson.regenPackData.order_item_id)
      if (regenPackOrderItem) {
        const regenPackOrderItemQuantity = regenPackOrderItem.querySelector("[data-quantity]")
        regenPackOrderItemQuantity.innerHTML = responseJson.regenPackData.quantity
        const regenPackOrderItemSubtotal = regenPackOrderItem.querySelector("[data-order-item-subtotal]")
        regenPackOrderItemSubtotal.innerHTML = '$' + parseFloat(responseJson.regenPackData.subtotal).toFixed(2)

        const regenPackCartListItem = this.ListItemTargets.find((target) => target.dataset.listItemId == responseJson.regenPackData.order_item_id)
        const regenPackCartListItemQuantity = regenPackCartListItem.querySelector("[name='order_item[quantity]']")
        regenPackCartListItemQuantity.value = responseJson.regenPackData.quantity

        this.RowTotalPriceTargets.find((target) => target.dataset.id == responseJson.regenPackData.order_item_id).innerHTML = '$' + parseFloat(responseJson.regenPackData.subtotal).toFixed(2)
      }
    }
  }

  async updateHighPurityNonGmoOrderItem(responseJson) {
    const hasHighPurityNonGmo = responseJson.hasHighPurityNonGmo
    if (hasHighPurityNonGmo) {
      const highPurityNonGmoOrderItem = this.SummaryOrderItemTargets.find((target) => target.dataset.orderItemId == responseJson.highPurityNonGmoData.order_item_id)
      if (highPurityNonGmoOrderItem) {
        const highPurityNonGmoOrderItemQuantity = highPurityNonGmoOrderItem.querySelector("[data-quantity]")
        highPurityNonGmoOrderItemQuantity.innerHTML = responseJson.highPurityNonGmoData.quantity
        const highPurityNonGmoOrderItemSubtotal = highPurityNonGmoOrderItem.querySelector("[data-order-item-subtotal]")
        highPurityNonGmoOrderItemSubtotal.innerHTML = '$' + parseFloat(responseJson.highPurityNonGmoData.subtotal).toFixed(2)

        const highPurityNonGmoCartListItem = this.ListItemTargets.find((target) => target.dataset.listItemId == responseJson.highPurityNonGmoData.order_item_id)
        const highPurityNonGmoCartListItemItemQuantity = highPurityNonGmoCartListItem.querySelector("[name='order_item[quantity]']")
        highPurityNonGmoCartListItemItemQuantity.value = responseJson.highPurityNonGmoData.quantity

        this.RowTotalPriceTargets.find((target) => target.dataset.id == responseJson.highPurityNonGmoData.order_item_id).innerHTML = '$' + parseFloat(responseJson.highPurityNonGmoData.subtotal).toFixed(2)
      }
    }
  }

  async updateOrderItemQuantity(e) {
    const form = e.target.form

    const request = new FetchRequest(form.method, form.action, { body: new FormData(form), responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      const responseJson = await response.json

      this.RowTotalPriceTargets.find((target) => target.dataset.id == responseJson.orderItemId).innerHTML = responseJson.orderItemTotal
      this.SummarySubtotalAmountTarget.innerHTML = responseJson.orderSubtotal
      const summaryOrderItem = this.SummaryOrderItemTargets.find((target) => target.dataset.orderItemId == responseJson.orderItemId)
      const summaryOrderItemQuantity = summaryOrderItem.querySelector("[data-quantity]")
      summaryOrderItemQuantity.innerHTML = responseJson.orderItemQuantity
      const summaryOrderItemSubtotal = summaryOrderItem.querySelector("[data-order-item-subtotal]")
      summaryOrderItemSubtotal.innerHTML = responseJson.orderItemTotal
      this.updateRegenPackOrderItem(responseJson)
      this.updateHighPurityNonGmoOrderItem(responseJson)

      this.quantityIsUpdating = false
    } else {
      const responseJson = await response.json
      if (!responseJson) {
        Sentry.captureMessage('Error updating item in cart: ' + response)
      }
      this.quantityIsUpdating = false
      alert("There was an error updating the quantity. Please try again or contact us for support")
    }
  }

  async onDeleteClick(e) {
    e.preventDefault()

    const orderItemId = e.currentTarget.dataset.id
    const title = e.currentTarget.dataset.title

    if (confirm(`Are you sure you want to delete '${title}' from your cart?`)) {
      this.showLoadingSpinner()

      const request = new FetchRequest("DELETE", `/order_items/${orderItemId}`, {  responseKind: 'json' })
      const response = await request.perform()

      if (response.ok) {
        const responseJson = await response.json

        this.updateRegenPackOrderItem(responseJson)
        this.updateHighPurityNonGmoOrderItem(responseJson)

        this.hideLoadingSpinner()
        const itemCount = responseJson.itemCount
        this.SummarySubtotalAmountTarget.innerHTML = responseJson.orderSubtotal

        if (itemCount === 0) {
          this.EmptyMessageTarget.classList.remove("hidden")
          this.HideOnEmptyTargets.forEach((target) => target.classList.add("hidden"))
        } else {
          this.ListTarget.classList.remove("hidden")
        }

        this.ListItemTargets.find((target) => target.dataset.listItemId == orderItemId).remove()

        const summaryOrderItem = this.SummaryOrderItemTargets.find((target) => target.dataset.orderItemId == orderItemId)
        if (summaryOrderItem) {
          summaryOrderItem.remove()
        }
        if (itemCount == 0) {
          this.SummaryOrderItemTargets.forEach((target) => target.remove())
        }
      } else {
        const responseJson = await response.json
        alert("There was an error removing this item from the cart.")
        this.LoadingSpinnerTarget.classList.innerHTML = "Please refresh the page."
        Sentry.captureMessage('Error deleting item from cart: ' + responseJson)
      }
    }
  }

  showLoadingSpinner() {
    this.ListTarget.classList.add("hidden")
    this.LoadingSpinnerTarget.classList.remove("hidden")
  }

  hideLoadingSpinner() {
    this.LoadingSpinnerTarget.classList.add("hidden")
  }

  onPromoSelect() {
    this.FullLoadingSpinnerTarget.classList.remove("hidden")
  }

  enableSubmitButton() {
    this.SubmitButtonTarget.disabled = false
    this.EarlySeasonPromoNoticeTarget.classList.add('hidden')
  }

}